import React from "react";
import "../css/ErrorPage.css";
import Layout from "./Layout";
import { DOMAIN_URL } from "../constants";
import { Translation } from "react-i18next";
import getCookie from "../function/getCookie";
import i18n from "i18next";

var lang = getCookie("hk-emphasis-language");
var path = lang === "en" ? "en" : "tc";

const find = [
  {
    href: DOMAIN_URL + `/${path}/products/Whatsnew-Whatsnew`,
    name: "errorPage.newIn"
  }
  // {
  //   href: DOMAIN_URL + "/en/product/WhatsNew-EditorsPick",
  //   name: "編輯推介"
  // },
  // {
  //   href: DOMAIN_URL + "/en/product/Wedding?page=0",
  //   name: "婚禮"
  // },
  // { href: DOMAIN_URL + "/en/product/Gifts", name: "禮品" }
];
const help = [
  {
    href: DOMAIN_URL + `/${path}/contact-us`,
    name: "errorPage.contact"
  },
  // {
  //   href: DOMAIN_URL + "/eshop-hk/en/reservation",
  //   name: "編輯推介"
  // },
  {
    href: DOMAIN_URL + `/${path}/help-overview`,
    name: "errorPage.help"
  },
  {
    href: DOMAIN_URL + `/${path}/store-locator`,
    name: "errorPage.storeLocation"
  }
];
class ErrorPage extends React.Component {
  componentDidMount() {
    window.location.assign(`${DOMAIN_URL}/${path}/404?proj=r&msg=errorpage`);
    // var lang = getCookie("eshop-hk-language");
    // if (lang === "en") {
    //   i18n.changeLanguage("en");
    //   this.setState({
    //     lang: "en"
    //   });
    // } else {
    //   i18n.changeLanguage("zhTW"); //繁體
    //   this.setState({
    //     lang: "zhTW"
    //   });
    // }
  }
  render() {
    return (
      <div className="errorPage" id="page404">
        {/* <Layout>
          <h1 className="text-title">
            <Translation>{t => <b>{t("errorPage.error404")}</b>}</Translation>
          </h1>
          <h3>
            <Translation>{t => <>{t("errorPage.sorry")}</>}</Translation>
            <br />
            <Translation>{t => <>{t("errorPage.canNotFind")}</>}</Translation>
          </h3>
          <Translation>{t => <h3>{t("errorPage.meanwhile")}</h3>}</Translation>

          <div className="cs1 paddingAlign">
            <div className="errorPage-box-top errorPage-box">
              <p>
                <Translation>{t => <>{t("errorPage.goback")}</>}</Translation>
                <Translation>
                  {t => (
                    <a className="fontColorStylePrimary" href={`/${path}/home`}>
                      {t("errorPage.home")}
                    </a>
                  )}
                </Translation>
              </p>
            </div>
            <div className="bgForErrorPage" />
            <div
              className="errorPage-box errorPage-box-top"
              style={{ marginLeft: "5px" }}
            >
              <Translation>
                {t => <p>{t("errorPage.futherAssistance")}</p>}
              </Translation>
              <Translation>
                {t => <p>{t("errorPage.hotline") + "+852 2192-3228"}</p>}
              </Translation>

              <p>
                <Translation>{t => <>{t("errorPage.email")}</>}</Translation>
                <a
                  className="fontColorStylePrimary"
                  href="mailto:eshop@emphasis.com"
                >
                  eshop@emphasis.com
                </a>
              </p>
            </div>
          </div>
          <div className="cs1 paddingAlign" style={{ paddingBottom: "30px" }}>
            <div className="errorPage-box padding">
              <h4 className="fontColorStylePrimary font-size-14">
                <Translation>
                  {t => <b>{t("errorPage.doYouFind")}</b>}
                </Translation>
              </h4>
              <nav>
                {find.map((item, i) => (
                  <a
                    className="errorPage-navs errorPage-navs1 fontColorStyleblack"
                    href={item.href}
                    key={i}
                  >
                    <Translation>{t => <>{t(item.name)}</>}</Translation>
                  </a>
                ))}
              </nav>
            </div>
            <div className="errorPage-box padding">
              <h4 className="fontColorStylePrimary font-size-14">
                <Translation>
                  {t => <b>{t("errorPage.needHelp")}</b>}
                </Translation>
              </h4>
              <nav>
                {help.map((item, i) => (
                  <a
                    className="errorPage-navs errorPage-navs1 fontColorStyleblack"
                    href={item.href}
                    key={i}
                  >
                    <Translation>{t => <>{t(item.name)}</>}</Translation>
                  </a>
                ))}
              </nav>
            </div>
          </div>
        </Layout> */}
      </div>
    );
  }
}

export default ErrorPage;
